export default "__VITE_ASSET__AlgASbjO__"